import {Box, Button, Typography} from "@mui/material";
import {useMq} from "@buildwitt/shapeshift-common/v1/hooks";
import {MarkedQuestion, MarkedQuestionsSummary} from "@buildwitt/shapeshift-common/v1/quiz";
import {FC} from "react";
import {makeStyles} from "tss-react/mui";
import {IMarkedQuizAnswers, IQuiz} from "@buildwitt/shapeshift-types";
import {palette} from "@/constants";
import {useSSTranslation} from "@/i18n/useSSTranslation";

const useStyles = makeStyles()((theme) => ({
	quizResult: {
		maxWidth: "1000px",
		margin: "40px auto 60px auto",
		textAlign: "left",
		[theme.breakpoints.down("sm")]: {
			marginTop: "15px"
		},
		"[class*='answerCounter']": {
			height: "36px",
			background: palette.grey10,
			boxSizing: "border-box",
			justifyContent: "center",
			display: "flex",
			flexDirection: "column",
			fontWeight: 600,
			fontSize: "14px"
		},
		"[class*='questionCounter']": {
			fontFamily: "Titillium Web,sans-serif",
			color: theme.palette.common.white
		},
		"[class*='questionOption']": {
			boxSizing: "border-box",
			border: palette.grey20 + " 1px solid",
			"[class*='childrenContainer']": {
				padding: "5px 13px"
			},
			"[class*='optionId']": {
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				textAlign: "center",
				height: "34px",
				background: palette.grey10,
				fontSize: "14px",
				fontWeight: 600,
				boxSizing: "border-box",
				width: "34px",
				borderRadius: "5px",
				border: palette.grey20 + " 1px solid"
			}
		}
	},
	markedAnswer: {
		marginBottom: "60px"
	},
	label: {
		lineHeight: 0,
		fontSize: "16px",
		marginBottom: "40px",
		marginTop: "100px",
		color: theme.palette.common.white,
		"& span": {
			color: theme.palette.primary.main
		}
	},
	title: {
		margin: "60px 0 20px 0"
	},
	subTitle: {
		marginBottom: "40px",
		color: theme.palette.common.white
	},
	retakeBtn: {
		height: "52px",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			marginBottom: "20px"
		}
	},
	markedQuestionsSummary: {
		"[class*='container']": {
			background: "#373737"
		}
	}
}));

interface IProps {
	quiz?: IQuiz;
	markedAnswers: IMarkedQuizAnswers;
	onRetake: () => void;
}

export const MiniQuizzerComplete: FC<IProps> = ({quiz, markedAnswers, onRetake}) => {
	const {classes} = useStyles();
	const mq = useMq();
	const {t} = useSSTranslation();

	return (
		<Box className={classes.quizResult}>
			<MarkedQuestionsSummary className={classes.markedQuestionsSummary} markedAnswers={markedAnswers} />
			{!mq.mobile ? (
				<>
					<Typography variant="h1" className={classes.title}>
						{quiz?.title}
					</Typography>
					<Typography variant="h4" className={classes.subTitle}>
						{t("quiz.pass_by_scoring", "Pass by scoring 100%")}
					</Typography>
				</>
			) : (
				<Box sx={{marginBottom: "40px"}} />
			)}
			{markedAnswers?.markedAnswers?.map((answer, i) => (
				<Box key={`marked-answer-${i}`} className={classes.markedAnswer}>
					<Typography className={classes.label}>
						{t("quiz.question_text", "Question")}{" "}
						<span>{i + 1}</span>{" "}
						{t("quiz.of_text", "of")}{" "}
						<span>{markedAnswers.markedAnswers.length}</span>
					</Typography>
					<MarkedQuestion markedAnswer={answer} />
				</Box>
			))}
			<Button className={classes.retakeBtn} onClick={onRetake}>
				{t("quiz.retake", "Retake")}
			</Button>
		</Box>
	);
};
